export const BUTTON_INITIAL_STATE = [
  {
    buttonText: 'GET STARTED',
    buttonUrl: 'http://builder.renderforestsites.com',
    type: 'primary'
  },
  {
    buttonText: 'LEARN MORE',
    buttonUrl: 'http://builder.renderforestsites.com',
    type: 'primary'
  }
]

export const validation = {
  maxTitleChar: 120,
  maxParagraphChar: 1500,
  buttons: {
    min: 0,
    max: 2
  }
}
